import { GeolocationError } from '@/store/slices/geolocation/types';

export type LOCATION_IN_PROGRESS =
  | 'aw-geolocation/location-in-progress'
  | 'geolocation-sdk/location-in-progress';
export type GEOLOCATION_PASSED =
  | 'aw-geolocation/geolocation-passed'
  | 'geolocation-sdk/geolocation-passed';
export type GEOLOCATION_REJECTED =
  | 'aw-geolocation/geolocation-rejected'
  | 'geolocation-sdk/geolocation-rejected';
export type LOCATION_FAILURE =
  | 'aw-geolocation/location-failure'
  | 'geolocation-sdk/location-failure';
export type GEOLOCATION_INVALIDATED =
  | 'aw-geolocation/geolocation-invalidated'
  | 'geolocation-sdk/geolocation-invalidated';

// Type guard functions
export function isLocationInProgress(
  value: string,
): LOCATION_IN_PROGRESS | boolean {
  if (
    value === 'aw-geolocation/location-in-progress' ||
    value === 'geolocation-sdk/location-in-progress'
  )
    return value;
  return false;
}

export function isGeolocationPassed(
  value: string,
): GEOLOCATION_PASSED | boolean {
  if (
    value === 'aw-geolocation/geolocation-passed' ||
    value === 'geolocation-sdk/geolocation-passed'
  )
    return value;
  return false;
}

export function isGeolocationRejected(
  value: string,
): GEOLOCATION_REJECTED | boolean {
  if (
    value === 'aw-geolocation/geolocation-rejected' ||
    value === 'geolocation-sdk/geolocation-rejected'
  )
    return value;
  return false;
}

export function isLocationFailure(value: string): LOCATION_FAILURE | boolean {
  if (
    value === 'aw-geolocation/location-failure' ||
    value === 'geolocation-sdk/location-failure'
  )
    return value;
  return false;
}

export function isGeolocationInvalidated(
  value: string,
): GEOLOCATION_INVALIDATED | boolean {
  if (
    value === 'aw-geolocation/geolocation-invalidated' ||
    value === 'geolocation-sdk/geolocation-invalidated'
  )
    return value;
  return false;
}

export type GeolocationRejection = { [key: string]: unknown }; //TO DO define the structure from the UM

export type LocationInProgress = {
  type: LOCATION_IN_PROGRESS;
  payload: {
    region?: string;
    product?: string;
  };
};

export enum GeolocationInvalidation {
  TokenExpired = 'tokenExpired',
  IpAddressChanged = 'ipAddressChanged',
}

export type GeolocationPassed = {
  type: GEOLOCATION_PASSED;
  payload: {
    region: string;
    product: string;
    jwt: string;
  };
};

export type GeolocationRejected = {
  type: GEOLOCATION_REJECTED;
  payload: {
    region: string;
    product: string;
    rejection: GeolocationRejection;
  };
};

export type LocationFailure = {
  type: LOCATION_FAILURE;
  payload: {
    region?: string;
    product?: string;
    error: GeolocationError;
  };
};

export type GeolocationResponse = {
  type: string;
  payload: {
    error?: { errorCode?: number };
    jwt?: string;
    region?: string;
    product?: string;
    rejection?: {
      message?: string;
      troubleshooters?: string;
    };
  };
};

export type GeolocationParams = {
  region: string;
  sessionId: string;
  userId: string;
  userAuthToken: string;
  geocomplyToken?: string;
  product: 'casino' | 'poker';
};

export type GeolocationInvalidatedEvent = {
  type: GEOLOCATION_INVALIDATED;
  payload: {
    region: string;
    product: string;
    invalidation: GeolocationInvalidation;
  };
};

export enum GeolocationProgress {
  NotStarted = 'not-started',
  InProgress = 'in-progress',
  Success = 'success',
  Failed = 'failed',
  Invalidated = 'invalidated',
}

export type Environment =
  | 'prod'
  | 'cert'
  | 'qa'
  | 'http://localhost:3000'
  | 'dev';

export type GeolocationProgressType = GeolocationProgress;

export const GEOLOCATION_WRAPPER_EVENTS = {
  GC_GEOLOCATION_PROGRESS: 'GC/GEOLOCATION_PROGRESS',
  GC_GEOLOCATION_FAILURE: 'GC/GEOLOCATION_FAILURE',
  GC_GEOLOCATION_SUCCESS: 'GC/GEOLOCATION_SUCCESS',
  GC_GEOLOCATION_REJECTED: 'GC/GEOLOCATION_REJECTED',
  GC_GEOLOCATION_INVALIDATED: 'GC/GEOLOCATION_INVALIDATED',
} as const;

export type WrapperToGameClientEventType =
  (typeof GEOLOCATION_WRAPPER_EVENTS)[keyof typeof GEOLOCATION_WRAPPER_EVENTS];

export type GeolocationWrapperEvent = {
  type: WrapperToGameClientEventType;
  payload: { [key: string]: unknown }; // TO DO define the structure from the Game Client
};

export type GeolocationNote = {
  type: 'verified' | 'pending';
  dismissing?: boolean;
  onDismissed?: () => void;
};
